export default __webpack_public_path__ + "static/media/bg02.2acb5c3b.svg";